import type { FunctionComponent } from 'react';

import { Card, getCardInfo } from '../../../../../game/card/card';
import { Overscrollable } from '../../../../../overscrollable';
import { AndarbaharHistoryResultProps } from '../../../gameInfo/results/andarbahar/AndarbaharHistoryResult';

import styles from './AndarbaharTableResult.module.css';

export const AndarbaharTableResult: FunctionComponent<AndarbaharHistoryResultProps> = ({ seats }) => {
  // FYI: sometimes the card tag from XML is not presented
  const andarCards = (seats[0].hand[1].card instanceof Array ? seats[0].hand[1].card : [seats[0].hand[1].card])
    .filter((card) => !!card)
    .map((card: string) => card.match(/\d+/)?.[0]) as string[];

  const baharCards = (seats[0].hand[2].card instanceof Array ? seats[0].hand[2].card : [seats[0].hand[2].card])
    .filter((card) => !!card)
    .map((card: string) => card.match(/\d+/)?.[0]) as string[];
  return (
    <div className={styles.history}>
      <div className={styles.cardsWrapper}>
        <div className={styles.cardColumn}>
          <div className={styles.cardTitle}>
            <span className={styles.cardName}>ANDAR</span>
          </div>
          <Overscrollable horizontal center>
            <div className={styles.cardRow}>
              {andarCards.slice(0, andarCards.length - 2).map((card: string, index: number) => (
                <Card key={index} mini className={styles.card} {...getCardInfo(parseInt(card))} />
              ))}
            </div>
          </Overscrollable>
          <div className={styles.cardMain}>
            <Card mini className={styles.card} {...getCardInfo(parseInt(andarCards[andarCards.length - 1]))} />
          </div>
        </div>
      </div>
      <div className={styles.cardsWrapper}>
        <div className={styles.cardColumn}>
          <div className={styles.cardTitle}>
            <span className={styles.cardName}>BAHAR</span>
          </div>
          <Overscrollable horizontal center>
            <div className={styles.cardRow}>
              {baharCards.slice(0, baharCards.length - 2).map((card: string, index: number) => (
                <Card key={index} mini className={styles.card} {...getCardInfo(parseInt(card))} />
              ))}
            </div>
          </Overscrollable>
          <div className={styles.cardMain}>
            <Card mini className={styles.card} {...getCardInfo(parseInt(baharCards[baharCards.length - 1]))} />
          </div>
        </div>
      </div>
    </div>
  );
};
